import { isEqual } from 'lodash';
import { AVAILABLE_FIELDS } from '../campaigns-filter.constants';

export const isSameRule = (
    { field: f1, operator: o1, value: v1 },
    { field: f2, operator: o2, value: v2 },
) => isEqual(f1, f2)
    && isEqual(o1, o2)
    && isEqual(v1, v2);

export const hasRule = (rulesList, rule) => Boolean(rulesList.find(r => isSameRule(r, rule)));

const buildRule = (rule) => {
    const { value: ruleValue } = rule;
    const value = Array.isArray(ruleValue) ? ruleValue : ruleValue.value;

    const newRule = {
        field: rule.field.value,
        operator: rule.operator.value,
        value,
    };

    return newRule;
};

export const getNewRules = (newRule, rules) => {
    const newRuleField = newRule.field.value;

    const { unique } = AVAILABLE_FIELDS.find(field => field.name === newRuleField);
    const isRuleAlreadyExistis = rules.find(rule => rule.field === newRuleField);
    const shouldReplaceRule = isRuleAlreadyExistis && unique;

    if (shouldReplaceRule) {
        return rules.map((rule) => {
            if (rule.field === newRuleField) {
                return buildRule(newRule);
            }
            return rule;
        });
    }

    return [...rules, buildRule(newRule)];
};
